import ViewHistorique from '@/views/consultations/historique/view-historique'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import $ from 'jquery'

export default {
    name: "historique",
    components: {
        ViewHistorique
    },
    props: [],
    data() {
        return {
            vm_state: open_menu_state,
            fields: [
                { key: "ref_bon", label: "Référence bon" }, { key: "ref_bon_parent", label: "Référence Parent" }, 
                { key: "type_consultation", label: "Type consultation" }, 'date', 'action.s'
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            list_consultation_loading: true,
            list_consultation_empty: false,
            is_historique: false,
            selected_consultation: {},
            event_trigger: 0
        };
    },

    computed: {
        patient() {
            return this.$store.getters["patient"];
        },

        userCredentials() {
            return this.$store.getters["authInfo"];
        },

        liste_consultations_patient() {
            return this.$store.getters["liste_consultations_patient"];
        },

        consultation_length() {
            return this.liste_consultations_patient.length;
        },
    },

    mounted() {
        const patient_id = this.$route.params.id
        this.getListConsultationPatien(patient_id)

        const ts = this;
        $(document).bind("click", function(e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        getListConsultationPatien(patient_id) {
            this.list_consultation_loading = true

            this.$store.dispatch('getListeConsultationsPatient', patient_id).then(() => {
                if (this.liste_consultations_patient.length == 0) {
                    this.list_consultation_empty = true
                } else {
                    this.list_consultation_empty = false
                }

                this.list_consultation_loading = false
            })
        },

        viewHistorique(data) {
            this.event_trigger = (this.event_trigger == 0)?1:0
            this.is_historique = true
            this.selected_consultation = data
        },

        backToListConsultation() {
            this.is_historique = false
        }
    },
};
